import httpClient from "./httpClient";

/** Record a coupon page view (optional body e.g. anonKey). */
export async function recordCouponView(couponPublicId, body = {}) {
  await httpClient.post(
    `/coupons/${encodeURIComponent(couponPublicId)}/views`,
    body
  );
}
